import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Auth via HttpOnly cookie (tidak ada token di JS). Double-submit CSRF token untuk request mutasi.
  if (['post', 'put', 'delete', 'patch'].includes((config.method || '').toLowerCase())) {
    const csrf = document.cookie.split('; ').find((c) => c.startsWith('ts_csrf='))?.split('=')[1];
    if (csrf) config.headers['X-CSRF-Token'] = csrf;
  }
  return config;
});

export function fileUrl(path) {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('/api/')) return path;
  return `${API}/files/${path}`;
}

// Derivative V1 (?w=): server meresolve record derivative milik parent; tanpa derivative
// (image lama belum dibackfill) server fallback ke original — tidak ada broken image.
// URL eksternal (unsplash dsb.) tidak diberi parameter.
export function fileWUrl(path, w) {
  const base = fileUrl(path);
  if (!base || !w) return base;
  if (base.startsWith('http') && !base.startsWith(BACKEND_URL)) return base;
  return base + (base.includes('?') ? '&' : '?') + `w=${w}`;
}

// URL same-origin yang TIDAK me-redirect ke R2 (?proxy=1) — untuk editor canvas
// (ImageCropper) agar canvas tidak tainted oleh resource cross-origin.
export function fileProxyUrl(path) {
  if (!path) return '';
  if (path.startsWith('data:') || path.startsWith('blob:')) return path;
  if (path.startsWith('http') && !path.startsWith(BACKEND_URL)) return path;
  const base = path.startsWith('/api/') ? `${BACKEND_URL}${path}` : fileUrl(path);
  return base + (base.includes('?') ? '&' : '?') + 'proxy=1';
}

export function formatRupiah(n) {
  if (n === null || n === undefined) return '-';
  return 'Rp ' + Number(n).toLocaleString('id-ID');
}

export function formatDate(iso) {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return iso;
  }
}

// Kebijakan 404 terpusat (SEO indexability): HANYA HTTP 404 eksplisit yang boleh memicu state
// "tidak ditemukan" (noindex). Error network/timeout/5xx sementara TIDAK boleh membuat halaman
// publik salah terbaca noindex oleh crawler (GSC WRS).
export const isNotFound = (e) => e?.response?.status === 404;
